var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"app-btn",class:[`app-btn--${_vm.variant}`, `app-btn--${_vm.size}`, { 'app-btn--block': _vm.block, 'app-btn--done': _vm.done }],attrs:{"type":_vm.type,"disabled":_vm.disabled || _vm.done}},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }